export var ChecklistItem;
(function (ChecklistItem) {
    ChecklistItem["NeedsScreening"] = "NEEDS_SCREENING";
    ChecklistItem["NeedsMatching"] = "NEEDS_MATCHING";
    ChecklistItem["NeedsZicassoResponse"] = "NEEDS_ZICASSO_RESPONSE";
    ChecklistItem["NeedsZicassoReviewRequest"] = "NEEDS_ZICASSO_REVIEW_REQUEST";
})(ChecklistItem || (ChecklistItem = {}));
